import type { IOffersSection } from '@bprotsyk/aso-core/lib/offers/section';

export function resolveSectionTitle(section?: IOffersSection, fallback = 'Default'): string {
  if (!section?.title) return fallback;

  const preferred = section.title.none || (section.title as any).NONE || section.title.en;
  if (typeof preferred === 'string' && preferred.trim()) return preferred.trim();

  const firstTranslation = Object.values(section.title).find(
    (value) => typeof value === 'string' && value.trim()
  );

  return typeof firstTranslation === 'string' ? firstTranslation.trim() : fallback;
}
